import { sampleRanges } from './meeting-speaker-model';
import type { CompanyMeeting, MeetingSpeaker } from './types';

/** Single-voice meetings have no comparison margin; own rows still support listening. */
export function enrollmentSamples(meeting: CompanyMeeting, voice: MeetingSpeaker) {
  const ranked = sampleRanges(meeting, voice);
  if (ranked.length) return ranked.slice(0, 3);
  return (meeting.segments ?? [])
    .filter(
      (row) =>
        row.speaker === voice.label &&
        (!row.participantId || row.participantId === voice.participantId) &&
        (!row.rawSpeaker || row.rawSpeaker === row.speaker) &&
        row.startMs != null &&
        row.endMs != null &&
        row.endMs - row.startMs >= 2500,
    )
    .slice(0, 3)
    .map((row) => ({
      index: row.index,
      startMs: row.startMs!,
      endMs: Math.min(row.endMs!, row.startMs! + 8000),
    }));
}

/** Self-identification is a question, never a match to an unenrolled person. */
export function enrollmentChoices(meeting: CompanyMeeting, userId?: string) {
  if (!userId || !meeting.canEdit || meeting.voice?.status !== 'current' || !meeting.fileId)
    return [];
  const own = meeting.participants?.find((p) => p.userId === userId);
  if (!own && meeting.createdBy !== userId) return [];
  return (meeting.speakers ?? []).filter(
    (voice) =>
      !voice.mergedInto &&
      voice.speechMs >= 60_000 &&
      (voice.kind === 'unknown' || voice.participantId === own?.id) &&
      enrollmentSamples(meeting, voice).length > 0,
  );
}
